"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MS_ADS_EVENTS = exports.pushToUET = void 0;
const pushToUET = msAdsEvent => {
  window.uetq = window.uetq || [];
  window.uetq.push('event', msAdsEvent.name, {});
};
exports.pushToUET = pushToUET;
exports.MS_ADS_EVENTS = {
  SUCCESSFUL_ACCOUNT_CREATION: {
    name: 'account_creation_succeed'
  }
};
//# sourceMappingURL=msads.js.map